
import { Box, Grid, IconButton, Typography, useTheme, Tooltip } from "@mui/material";
import Modal from "../../Modal";
import { Close } from "@mui/icons-material";
import { ReactComponent as DS24QrCode } from '../../../../assets/icons/icon_download_app_qr.svg'


function ModalDownloadAppQR({ open, onClose }) {
  const theme = useTheme()

  return(
    <Modal open={open} onClose={onClose} sxContent={{ width: { xs: 'auto', md: '34rem' },  borderRadius: '20px' }}>
      <Box p={3.5}>
        <Grid container>
          <Grid item container alignItems='center' justifyContent='flex-end'>
            <Tooltip title='Закрыть' placement="top">
              <IconButton onClick={onClose}>
                <Close />
              </IconButton>
            </Tooltip>
          </Grid>

        <Grid item sx={{ display: 'flex' }} gap={4}>
          <Box><DS24QrCode /></Box>
          <Grid container item sx={{ flexDirection: 'column', gap: 2 }}>
            <Typography sx={{ fontSize: '28px', fontWeight: 500, lineHeight: 1 }}>Скачать приложение</Typography>
            <Typography sx={{ wordBreak: 'break-word', maxWidth: '13rem' }}>
              Отсканируйте QR‑код или{' '}
              <a href="https://stqr.ru/-/ds24ru" rel="noreferrer" target="_blank"  style={{ color: theme.palette.text.link, textDecoration: 'none' }}>
                перейдите по ссылке
              </a>
            </Typography>
          </Grid>
        </Grid>
        
        </Grid>   
      </Box>
    </Modal>
  )
}

export default ModalDownloadAppQR;